<div class="container mw-100 pb-0 team-overview">
  <nav class="breadcrumb">
    <button class="breadcrumb-link" (click)="goToTeams()" type="button" mat-button color="primary"
      class="material-default">
      Teams
    </button>
    <span *ngIf="teamId"> / </span>
    <span *ngIf="teamId" class="breadcrumb-item">{{ teamName?.toUpperCase() }}</span>
  </nav>
    <div class="page-heading">
      <div>
        {{ teamName }}
      </div>
      <button *ngIf="hasAccessToManageTeams" (click)="editTeams()" type="button" mat-button color="primary"
        class="edit-btn">
        <mat-icon color="edit">edit</mat-icon>
        EDIT TEAM
      </button>
    </div>
    <mat-tab-group [selectedIndex]="1">
      <mat-tab label="Members">
        <ng-template matTabContent>
            <manage-team-members-table
                [data]="teamMembers"
                [displayedColumns]="displayedColumns"
                initialSort="name"
                (tableEvent)="tableAction($event)"
            >
            </manage-team-members-table>
        </ng-template>
      </mat-tab>
      <mat-tab label="Schedule">
        <ng-template matTabContent>
            <manage-team-members-schedule
                [id]="teamId"
                [selectedDate]="selectedDate"
                [setSelectedDate]="setSelectedDate.bind(this)"
            >
            </manage-team-members-schedule>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
</div>